Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-disqus-widget', function (envelope) {

        var $context = envelope.message.data.context,
        	$wrapper = $('.x-disqus-widget');

        if ($wrapper.length < 1)
            return;

        var identifier = $wrapper.data('disqus-id');
        var disqusUrl = $wrapper.data('disqus-url');
        
        if (window.DISQUS) {
            //if Disqus exists, call it's reset method with new parameters
            DISQUS.reset({
                reload: true,
                config: function () {
                    this.page.identifier = identifier;
                    this.page.url = url;
                }
            });
        } else {
            $('<div id="disqus_thread"></div>').appendTo($('.x-disqus-widget'));
            
            Vendd.User.AuthProviders.disqus.init($wrapper, identifier, disqusUrl);
        }

        if (!Vendd.User.AuthProviders.disqus)
            throw new Error('Disqus vendd auth provider not found');

    });
});